import React from 'react';
import "../../../../node_modules/video-react/dist/video-react.css";
import "components/General/Video/Video.css";
import TextTheme from "components/General/Text/TextTheme";


class FooterSection extends React.Component {

    render() {
        return (
            <div>
                <div className="columnhead">
                    <TextTheme
							message={this.props.title}
							className="text_medium text_med_bright_blue"
						/>

                </div>
                {this.props.content?
                    (
                        this.props.content.map(value => (
                            value.location==='External'?
                            (
                            <a key={value.content} rel="noreferrer" target="_blank" style={{color:"#FFFFFF"}} href={value.link}>{value.content}</a>
                            ):
                            (
                            <a key={value.content} style={{color:"#FFFFFF"}} href={value.link}>{value.content}</a>
                            )
                      ))
                    )
                    :null}
            </div>
        );
    }
}


export default FooterSection;